"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return Checkbox;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var Checkbox = {
    baseStyle: {
        label: {
            color: "text-primary",
            _disabled: {
                color: "text-disabled",
                opacity: 1
            }
        },
        control: {
            background: "background-action-default",
            borderColor: "ui-element-outline-default",
            color: "text-primary",
            _checked: {
                background: "primary-default",
                borderColor: "primary-default",
                _hover: {
                    background: "primary-hover",
                    borderColor: "primary-hover"
                },
                _disabled: {
                    borderColor: "ui-element-outline-disabled",
                    background: "background-action-disabled",
                    color: "text-disabled"
                }
            },
            _focus: {
                boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
            },
            _disabled: {
                background: "background-action-disabled",
                borderColor: "ui-element-outline-disabled"
            },
            _invalid: {
                borderColor: "alert-error-default"
            }
        },
        container: {
            alignItems: "start"
        }
    },
    sizes: {
        s: function(param) {
            var theme = param.theme;
            return {
                control: {
                    h: 3,
                    w: 3,
                    mt: "0.25rem"
                },
                label: {
                    textStyle: "text-body-meta-regular"
                },
                icon: _object_spread({}, theme.components.Icon.sizes.xs)
            };
        },
        m: function(param) {
            var theme = param.theme;
            return {
                control: {
                    w: 4,
                    h: 4,
                    mt: "0.25rem"
                },
                label: {
                    textStyle: "text-body-regular"
                },
                icon: _object_spread({}, theme.components.Icon.sizes.s)
            };
        },
        l: function(param) {
            var theme = param.theme;
            return {
                control: {
                    w: 5,
                    h: 5,
                    mt: "0.25rem"
                },
                label: {
                    textStyle: "text-body-large-regular"
                },
                icon: _object_spread({}, theme.components.Icon.sizes.m)
            };
        }
    },
    defaultProps: {
        size: "m"
    }
};
